import * as React from 'react';
/*import {
    useRedirect,
} from 'react-admin';*/

import EditComponentAdmin from "../../_common/EditComponentAdmin";
import PromotionEditCreate from "./PromotionEditCreate";
import {useRedirect} from "react-admin";
import {copyToS3bucket} from "../../_common/Transform";
import moment from "moment/moment";

/*const transformPromotion = (data) => {
    // data.source = data.source2;
    // delete data.source2;

    // data.date_from = moment(data.date_from).format('YYYY-MM-DDT:00:00:00') + '.000Z'
    // data.date_to = moment(data.date_to).format('YYYY-MM-DDT:00:00:00.000Z')
    console.log('TRANSFORM===>', data.date_from)
    console.log('TRANSFORM===>', data.to)
    data = copyToS3bucket('dPromotion', data)
    return data;
}*/
export const PromotionEdit = props => {
    const {location, resource} = props;
    const {search} = location;
    let idSource = '';
    if(search){
        let url = new URL('https://test/' + search);
        idSource = url.searchParams.get('customerId')
    }
    const redirect = useRedirect()

    return (
        <EditComponentAdmin
            {...props}
            // transform={transformPromotion}
            transform={(event) => copyToS3bucket(resource, event)}
            title={''}
            //editDialog={idSource}
            onSuccess={() => idSource ? props.history.goBack() : redirect('list', props.basePath)}
            /*onSuccess={() => idSource
                ? redirect(`/locating/${idSource}/2`)
                : redirect('list', props.basePath)
            }*/
            //fullWidth
            //   undoable={false} //Подтверждение удаления
            //   actions={<PostEditActions/>}
        >
            <PromotionEditCreate idSource={idSource}/>
        </EditComponentAdmin>
    )
};